import { Paper, Box, Grid } from '@mui/material';
import CriteriosIcon from '../../../assets/icons/criterios.icon';
import DashedBtn from '../../../components/dashed-button.component';
import { EditItemRow } from '../../../components/edit-item-row.component';
import { HeaderEdit } from '../../../components/header-edit.component';
import { useEditFormGeneralIndicators } from './hooks/useEditFormGeneralIndicators';
import VerticalStepper from '../../../components/vertical-stepper-fixed.component';
import styles from './styles/stepper-styles.module.css';
import { Button } from '../../../components/main-button.component';
import { IAdaptedValues } from '../../../interfaces/edit-adapted-values';
import {
	LABELS_GENERAL_INDICATOR_1,
	LABELS_SPECIFIC_INDICATOR_1,
} from '../utils/labels-header';
import { GoBack } from '../../../components/go-back-component';
import { IIndicatorModel } from '../../../interfaces/project.interface';

interface IEditFormGeneralIndicators {
	idActivity: string;
	isGeneralIndicator: boolean;
	setStep: React.Dispatch<React.SetStateAction<number>>;
	setCurrentIndicator: React.Dispatch<React.SetStateAction<IAdaptedValues>>;
	structureData: IIndicatorModel;
}

export const EditFormIndicators = ({
	idActivity,
	isGeneralIndicator,
	structureData,
	setStep,
	setCurrentIndicator,
}: IEditFormGeneralIndicators) => {
	const {
		indicatorsOptions,
		matches,
		handleNewIndicator,
		navigate,
		onSave,
		onEdit,
		onDelete,
	} = useEditFormGeneralIndicators({
		idActivity,
		isGeneralIndicator,
		setStep,
		setCurrentIndicator,
		structureData,
	});

	return (
		<>
			{!isGeneralIndicator && <GoBack action={() => setStep(0)} />}
			<Paper>
				<Box padding={3}>
					<Grid
						container
						spacing={3}
						justifyContent={matches ? 'center' : 'flex-end'}
						alignItems="center"
					>
						<HeaderEdit
							section="Criterios"
							title={
								isGeneralIndicator
									? LABELS_GENERAL_INDICATOR_1.title
									: LABELS_SPECIFIC_INDICATOR_1.title
							}
							alertText={
								isGeneralIndicator
									? LABELS_GENERAL_INDICATOR_1.alertText
									: LABELS_SPECIFIC_INDICATOR_1.alertText
							}
							icon={<CriteriosIcon size="23px" />}
						/>
						<Grid item xs={12}>
							<VerticalStepper
								gridKey="criterios-table"
								sxContainer={styles.containerVerticalStepper}
								sxElement={styles.verticalStepperSxElement}
								items={indicatorsOptions}
								renderItem={(item, column) => (
									<EditItemRow
										item={item}
										column={column}
										onEdit={onEdit}
										onSave={onSave}
										onDelete={onDelete}
									/>
								)}
							/>
						</Grid>
						<Grid item xs={12}>
							<DashedBtn
								onClick={() => handleNewIndicator()}
								width="100"
								text="Agregar indicador"
								disabled={
									!indicatorsOptions.every((element) => element.id)
								}
							/>
						</Grid>
						<Grid item>
							<Button
								label="Salir"
								onClick={() => navigate(-1)}
								variant="solid"
								style={{
									width: '200px',
								}}
							/>
						</Grid>
					</Grid>
				</Box>
			</Paper>
		</>
	);
};
